import { render, staticRenderFns } from "./BandGlide.vue?vue&type=template&id=5987cee3&scoped=true&"
import script from "./BandGlide.vue?vue&type=script&lang=js&"
export * from "./BandGlide.vue?vue&type=script&lang=js&"
import style0 from "./BandGlide.vue?vue&type=style&index=0&id=5987cee3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987cee3",
  null
  
)

export default component.exports